<!-- Intro Header -->
<header class="sdg-status">
  <div class="intro-body" appDynamicDirection>
    <div class="container">
      <div class="col-md-12">
        <div class="row" appDynamicDirection>
          <div class="col-sm-6 title">
            <h4 class="page-heading" i18n>Water-Related Sustainable Development Goals</h4>
            <h2 class="intro-text" i18n>Status - Questionnaire</h2>
          </div>
          <div class="col-sm-6">
            <!-- <a (click)="resourcesBtnClick()" class="col-xs-12 col-sm-6 col-md-8 btn btn-circle-sm text-center "
               style="margin-bottom: 15px;">
              <span i18n>Resources</span>
            </a> -->
            <a (click)="quesBtnClick()"
               class="col-xs-12 col-sm-6 col-md-8 btn btn-circle-sm text-center "
               style="margin-bottom: 15px; background: #1f487c;">
              <span i18n>Questionnaire</span>
            </a>
            <!-- <a (click)="dataBtnClick()" class="col-xs-12 col-sm-6 col-md-8 btn btn-circle-sm text-center"
               style="margin-bottom: 15px;">
              <span i18n>Data</span>
            </a> -->
            <a (click)="reportBtnClick()" class="col-xs-12 col-sm-6 col-md-8 btn btn-circle-sm text-center"
               style="margin-bottom: 15px;">
              <span i18n>Reporting</span>
            </a>
          </div>
          <div class="content-section" appDynamicDirection>
            <p i18n>The questionnaire for the ‘Status’ component aims to present the data that will allow assessment of each SDG 6 target and indicator while considering aspiration in 2030. This questionnaire is organised systematically. At the bottom of the page, a button allows the user to save the answers already entered in the questionnaire.
              <br>
              For more information and description of this component, please go to the
              ​<a href="{{src_pdf}}" download><strong> User Guide</strong></a>​.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>

<form name="form" (ngSubmit)="submitForm(f.form.valid)" #f="ngForm" *ngIf="sdgcomponent$ | async as sdgcomponent">

  <section class="content-section" *ngFor="let cat of status_comp.category; let i = index">
    <div class="container" appDynamicDirection>
      <div class="row" *ngIf="cat.name!='6.0'">
        <div class="col-md-12">
          <div class="table-h1 text-center">
            <a href="{{admin_url}}admin/pss_app/category/{{cat.id}}/change/" *ngIf="testmode" class="edit-link"
               target="_blank">edit</a>
            <!-- {lang, plural, =2 {{{cat.name_fr}}} =3 {{{cat.name_es}}} =4 {{{cat.name_ko}}} other {{{cat.name}}} } -->

            {lang, plural, =2 {{{cat.name_fr}}} =3 {{{cat.name_es}}} =4 {{{cat.name_pt}}} =5 {{{cat.name_ko}}} =6 {{{cat.name_ar}}} other {{{cat.name}}} }
            <button *ngIf="lang==1 && cat.description" type="button" class="guide-btn" (click)="openGuide(cat.description)">?</button>
            <button *ngIf="lang==2 && cat.description_fr" type="button" class="guide-btn" (click)="openGuide(cat.description_fr)">?</button>
            <button *ngIf="lang==3 && cat.description_es" type="button" class="guide-btn" (click)="openGuide(cat.description_es)">?</button>
            <button *ngIf="lang==4 && cat.description_pt" type="button" class="guide-btn" (click)="openGuide(cat.description_pt)">?</button>
            <button *ngIf="lang==5 && cat.description_ko" type="button" class="guide-btn" (click)="openGuide(cat.description_ko)">?</button>
            <button *ngIf="lang==6 && cat.description_ar" type="button" class="guide-btn" (click)="openGuide(cat.description_ar)">?</button>
          </div>
        </div>
      </div>

      <!--      <div class="row" *ngIf="cat.description">
              <div class="col-md-12">
                <div class="questions-section">
                  <a href="{{admin_url}}admin/pss_app/category/{{cat.id}}/change/" *ngIf="testmode" class="edit-link" target="_blank">edit</a>
                    <p *ngIf="lang==1" [innerHTML]="cat.description"></p>
                    <p *ngIf="lang==2" [innerHTML]="cat.description_fr"></p>
                    <p *ngIf="lang==3" [innerHTML]="cat.description_es"></p>
                    <p *ngIf="lang==4" [innerHTML]="cat.description_ko"></p>
                </div>
              </div>
            </div>-->

      <div *ngFor="let subcat of cat.sub_category; let j = index">

        <div class="row" appDynamicDirection *ngIf="subcat.name!='6.0.1'">
          <div class="col-md-12">
            <div class="table-h2 text-center">
              <a href="{{admin_url}}admin/pss_app/subcategory/{{subcat.id}}/change/" *ngIf="testmode" class="edit-link"
                 target="_blank">edit</a>
              <!-- {lang, plural, =2 {{{subcat.name_fr}}} =3 {{{subcat.name_es}}} =4 {{{subcat.name_ko}}} other {{{subcat.name}}} } -->

              {lang, plural, =2 {{{subcat.name_fr}}} =3 {{{subcat.name_es}}} =4 {{{subcat.name_pt}}} =5 {{{subcat.name_ko}}} =6 {{{subcat.name_ar}}} other {{{subcat.name}}} }
            <button *ngIf="lang==1 && subcat.description" type="button" class="guide-btn" (click)="openGuide(subcat.description)">?</button>
            <button *ngIf="lang==2 && subcat.description_fr" type="button" class="guide-btn" (click)="openGuide(subcat.description_fr)">?</button>
            <button *ngIf="lang==3 && subcat.description_es" type="button" class="guide-btn" (click)="openGuide(subcat.description_es)">?</button>
            <button *ngIf="lang==4 && subcat.description_pt" type="button" class="guide-btn" (click)="openGuide(subcat.description_pt)">?</button>
            <button *ngIf="lang==5 && subcat.description_ko" type="button" class="guide-btn" (click)="openGuide(subcat.description_ko)">?</button>
            <button *ngIf="lang==6 && subcat.description_ar" type="button" class="guide-btn" (click)="openGuide(subcat.description_ar)">?</button>

            </div>
          </div>
        </div>

        <!--      <div class="row" *ngIf="subcat.description">
                <div class="col-md-12">
                  <div class="questions-section">
                    <a href="{{admin_url}}admin/pss_app/subcategory/{{subcat.id}}/change/" *ngIf="testmode" class="edit-link" target="_blank">edit</a>
                      <p *ngIf="lang==1" [innerHTML]="subcat.description"></p>
                      <p *ngIf="lang==2" [innerHTML]="subcat.description_fr"></p>
                      <p *ngIf="lang==3" [innerHTML]="subcat.description_es"></p>
                      <p *ngIf="lang==4" [innerHTML]="subcat.description_ko"></p>
                  </div>
                </div>
              </div>-->

        <div *ngFor="let quecat of subcat.question_category; let k = index">
          <div class="row" appDynamicDirection *ngIf="quecat.name=='6.0.1.0'">
            <div class="col-md-12">
              <div class="table-h1 text-center" i18n>
                Supporting Information
              </div>
            </div>
          </div>
          <div class="table-h1">
            <div class="row" appDynamicDirection *ngIf="!(quecat.name=='6.0.1.0')">
              <div class="col-md-4 col-md-offset-8">
                <div class="answers-section3eq input-section" *ngIf="quecat.question_type=='Tabular'">
                  <div class="column">{{option_translation(quecat.option1, lang)}}</div>
                  <div class="column">{{option_translation(quecat.option2, lang)}}</div>
                  <div class="column">{{option_translation(quecat.option3, lang)}}</div>
                </div>
              </div>
            </div>
          </div>

          <div *ngFor="let ques of quecat.question; let l = index">
            <div *ngIf="quecat.question_type=='Tabular' && ques && ques.question_type!='Year'" class="question-section">
              <div class="row" appDynamicDirection *ngIf="ques.grp">
                <div class="col-md-8">
                  <div class="questions" appDynamicDirection>
                    <a href="{{admin_url}}admin/pss_app/question/{{ques.id}}/change/" *ngIf="testmode" class="edit-link"
                       target="_blank">edit</a>
                    <p *ngIf="lang==1" [innerHTML]="ques.question_text"></p>
                    <p *ngIf="lang==2" [innerHTML]="ques.question_text_fr"></p>
                    <p *ngIf="lang==3" [innerHTML]="ques.question_text_es"></p>
                    <p *ngIf="lang==4" [innerHTML]="ques.question_text_pt"></p>
                    <p *ngIf="lang==5" [innerHTML]="ques.question_text_ko"></p>
                    <p *ngIf="lang==6" [innerHTML]="ques.question_text_ar"></p>
                    <button *ngIf="lang==1 && ques.description" type="button" class="guide-btn" (click)="openGuide(ques.description)">?</button>
                    <button *ngIf="lang==2 && ques.description_fr" type="button" class="guide-btn" (click)="openGuide(ques.description_fr)">?</button>
                    <button *ngIf="lang==3 && ques.description_es" type="button" class="guide-btn" (click)="openGuide(ques.description_es)">?</button>
                    <button *ngIf="lang==4 && ques.description_pt" type="button" class="guide-btn" (click)="openGuide(ques.description_pt)">?</button>
                    <button *ngIf="lang==5 && ques.description_ko" type="button" class="guide-btn" (click)="openGuide(ques.description_ko)">?</button>
                    <button *ngIf="lang==6 && ques.description_ar" type="button" class="guide-btn" (click)="openGuide(ques.description_ar)">?</button>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="input-section-status">

                    <div class="column" appDynamicDirection>
                      <div *ngFor="let q1 of [questions[quesid_grp[ques.question_grp][0]]]">
                        <input name="name{{q1.id}}" class="form-control"
                               [(ngModel)]="values[quesid_grp[ques.question_grp][0]].value"
                               #baseline="ngModel" [required]="q1.required" [pattern]="q1.pattern" tabindex="l">
                        <div *ngIf="baseline.invalid && (baseline.dirty || baseline.touched || submit_attempted)"
                             class="alert alert-danger">
                          <div *ngIf="baseline.errors.required && q1.required">
                            Required
                          </div>
                          <div *ngIf="baseline.errors.pattern && q1.is_pattern">
                            {{q1.pattern_error}}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="column">
                      <div *ngIf="quesid_grp[ques.question_grp][1]">
                        <div *ngFor="let q2 of [questions[quesid_grp[ques.question_grp][1]]]">
                          <input name="current{{q2.id}}" class="form-control"
                                 [(ngModel)]="values[quesid_grp[ques.question_grp][1]].value"
                                 #current="ngModel" [required]="q2.required" [pattern]="q2.pattern" tabindex="l+1">
                          <div *ngIf="current.invalid && (current.dirty || current.touched || submit_attempted)"
                               class="alert alert-danger">
                            <div *ngIf="current.errors.required && q2.required">
                              Required
                            </div>
                            <div *ngIf="current.errors.pattern && q2.is_pattern">
                              {{q2.pattern_error}}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="column">
                      <div *ngIf="quesid_grp[ques.question_grp][2]">
                        <div *ngFor="let q3 of [questions[quesid_grp[ques.question_grp][2]]]">
                          <input name="aspiration{{q3.id}}" class="form-control"
                                 [(ngModel)]="values[quesid_grp[ques.question_grp][2]].value"
                                 #aspiration="ngModel" [required]="q3.required" [pattern]="q3.pattern" tabindex="l+2">
                          <div
                            *ngIf="aspiration.invalid && (aspiration.dirty || aspiration.touched || submit_attempted)"
                            class="alert alert-danger">
                            <div *ngIf="aspiration.errors.required && q3.required">
                              Required
                            </div>
                            <div *ngIf="aspiration.errors.pattern && q3.is_pattern">
                              {{q3.pattern_error}}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="container" >
    <div class="form-group col-md-6 col-md-offset-6" style="margin-top: 15px;">
      <div class="pull-right"><span *ngIf="this.last_saved">Last Saved On: {{this.last_saved | date:'medium'}}</span>
        <button (click)="this.is_partial='false'" [disabled]="loading" class="btn btn-floating btn-default" i18n>Submit Form
          <img *ngIf="loading && is_partial=='false'"
               src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="/>
        </button>
        <button (click)="this.is_partial='true'" [disabled]="loading" class="btn btn-floating btn-primary save_button" i18n>
          Save
          <img *ngIf="loading && is_partial=='true'"
               src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="/>
        </button>
      </div>
    </div>
  </div>
</form>

<!-- Guide Panel -->
<div class="guide-panel" [class.guide-panel-open]="guidePanelOpen">
  <div class="guide-panel-header">
    <span i18n>Guide</span>
    <button type="button" class="guide-close-btn" (click)="closeGuide()">&#x2715;</button>
  </div>
  <div class="guide-panel-body">
    <div [innerHTML]="guideText"></div>
    <div *ngIf="guideLinks.length > 0" class="guide-links-section">
      <div class="guide-links-title">Links</div>
      <ul class="guide-links-list">
        <li *ngFor="let link of guideLinks">
          <a [href]="link.url" target="_blank">{{link.label}}</a>
        </li>
      </ul>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/sdg/status-quest/status-quest.component.html